export const allowDomains = ['pohodnik.tk', 'pohodnik58.ru', 'pohodnik.github.io'];

export const getDomain = () => {
  if (allowDomains.includes(location.host)) return location.host;

  return allowDomains[0];
};
